// components/ExportMenu.tsx
// Bouton « Exporter » + boîte de formats collée au bouton (Popover antd,
// placement leftTop + flèche pointée vers le bouton).
// Le contenu est un Menu antd (items <li>) : le contexte disabled du Form
// ne peut pas griser les options — contrairement aux anciens boutons.
import React, { useState } from "react";
import { Button, Menu, Popover } from "antd";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TableChartIcon from '@mui/icons-material/TableChart';
import ArticleIcon from '@mui/icons-material/Article';
import DescriptionIcon from '@mui/icons-material/Description';

const FORMATS = [
  { key: 'excel', label: 'Excel (.xlsx)', icon: <TableChartIcon color="primary" fontSize="small" /> },
  { key: 'pdf', label: 'PDF (.pdf)', icon: <PictureAsPdfIcon color="error" fontSize="small" /> },
  { key: 'word', label: 'Word (.docx)', icon: <DescriptionIcon sx={{ color: "#2B579A" }} fontSize="small" /> },
  { key: 'csv', label: 'CSV (.csv)', icon: <ArticleIcon color="info" fontSize="small" /> },
  { key: 'json', label: 'JSON (.json)', icon: <ArticleIcon color="secondary" fontSize="small" /> },
];

// Safe Care : les exporteurs attendent les clés 'pdf' / 'xlsx' / 'docx'
export const EXPORT_FORMATS_DOCS = [
  { key: 'pdf', label: 'PDF (.pdf)', icon: <PictureAsPdfIcon color="error" fontSize="small" /> },
  { key: 'xlsx', label: 'Excel (.xlsx)', icon: <TableChartIcon color="primary" fontSize="small" /> },
  { key: 'docx', label: 'Word (.docx)', icon: <DescriptionIcon sx={{ color: "#2B579A" }} fontSize="small" /> },
];

export default function ExportMenu({ disabled, onExport, formats = FORMATS }: { disabled?: boolean; onExport: (format: string) => void; formats?: typeof FORMATS }) {
  const [open, setOpen] = useState(false);
  return (
    <Popover
      trigger="click"
      placement="leftTop"
      arrow={{ pointAtCenter: true }}
      open={open}
      onOpenChange={setOpen}
      content={
        <Menu
          selectable={false}
          style={{ border: 'none', minWidth: 170 }}
          items={formats.map(f => ({ key: f.key, icon: f.icon, label: f.label }))}
          onClick={({ key }) => { setOpen(false); onExport(String(key)); }}
        />
      }
    >
      <span style={{ display: 'block', width: '100%' }}>
        <Button size='large' className='bt_add' disabled={disabled} type="ghost" htmlType="button" block>
          Exporter
        </Button>
      </span>
    </Popover>
  );
}
